<template>
  <chart-container :titleChart="title" @onCSVDownload="downloadCSVGraphs()" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="containerId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0 && Object.keys(dataSource.categories[0].category).length > 0">
    <fusioncharts slot="body" class="fusion-bar-chart" style="width: 100%;" :type="type" width="100%" :height="height" dataFormat="json" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="timeActiveStatusPercentage" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0 && Object.keys(dataSource.categories[0].category).length > 0" />
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import { downloadCSV } from "../../services/visualization/recruitment";
import ChartContainer from "@/components/containers/chart-container";
import _ from "lodash";

export default {
  props: {
    vis: { type: Object, default: null },
    title: {
      type: String,
      default: "Default Apex Bar Card Title"
    },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      newVis: this.vis,
      data: null,
      apexBarData: null,
      zoomGraphValueChild: "",
      type: "scrollcolumn2d",
      dataSource: {},
      height: "250"
    };
  },
  watch: {
    vis() {
      this.newVis = this.vis;
      this.vis && this.processData();
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    }
  },
  components: {
    ChartContainer
  },
  methods: {
    downloadCSVGraphs() {
      let theAverage = [];
      if (this.specificSiteId.length > 0) {
        theAverage = [];
      } else {
        theAverage = this.newVis.apexData.trendlines[0].line[0].displayvalue;
      }
      if (this.containerId === "site-active-fpfv") {
        const header = ["site_name", "country_name", "site_active_date", "fpi_date", "num_days"];
        const newArr = [];

        const orderArr = _.orderBy(this.newVis.data, ["numDays"], ["desc"]);
        orderArr.map(row => {
          newArr.push([row.site, row.country, row.activeDate.toUpperCase(), row.date.toUpperCase(), row.numDays]);
        });
        downloadCSV(this.title, header, newArr, [theAverage], this.specificSiteId);
      } else {
        const header = ["site_name", "country_name", "site_active_date", "first_data_date", "num_days", "first_participant"];
        const newArr = [];

        const orderArr = _.orderBy(this.newVis.data, ["numDays"], ["desc"]);
        orderArr.map(row => {
          newArr.push([row.site, row.country, row.activeDate.toUpperCase(), row.date.toUpperCase(), row.numDays, row.firstParticipant]);
        });
        downloadCSV(this.title, header, newArr, [theAverage], this.specificSiteId);
      }
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    processData() {
      if (this.newVis) {
        this.dataSource = this.newVis.apexData;
        if (this.specificSiteId.length > 0) {
          this.dataSource.chart.xaxisname = "";
        }
      }
    }
  }
};
</script>
